import { render } from "./BakerOverview.vue?vue&type=template&id=03586610&scoped=true"
import script from "./BakerOverview.vue?vue&type=script&lang=js"
export * from "./BakerOverview.vue?vue&type=script&lang=js"

import "./BakerOverview.vue?vue&type=style&index=0&id=03586610&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03586610"]])

export default __exports__